export default "__VITE_ASSET__a10556af__"